import { render, staticRenderFns } from "./ImportExportWorkflow.vue?vue&type=template&id=15388982"
import script from "./ImportExportWorkflow.vue?vue&type=script&lang=js"
export * from "./ImportExportWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports